module.exports = __webpack_public_path__ + "img/17847_S.8b859d97.png";